import { Component, OnInit, ViewChild, Input, Output, EventEmitter, ElementRef, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AuthenticationService } from '../shared/auth/authentication.service';
import { ILogin } from '../shared/models/login';
import { IUser, IPermission } from '../shared/models/user';
import { RegisterService } from '../shared/providers/register.service'
import { IRegister } from '../shared/models/register.model';
import { IRegisterOutput } from '../shared/models/registeroutput.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToastService } from '../shared/providers/toast.service';
import { IForgotPassword } from '../shared/models/forgotpasswordInput';
import { ForgotPasswordService } from '../shared/providers/forgot-password.service';
import { ResultOutputModel } from '../shared/models/resultOutputModel';
//import { AuthService } from 'angularx-social-login';
//import { SocialUser } from 'angularx-social-login';
//import { GoogleLoginProvider, FacebookLoginProvider, LinkedInLoginProvider } from 'angularx-social-login';
import { SocialLoginInputModel } from '../shared/models/SocialLoginInputModel'
import { SocialLoginOutputModel } from '../shared/models/SocialLoginOutputModel'
import { CommonService } from '../shared/providers/common.service'
import { IUserRole } from '../shared/models/UserRoleOutputModel';
import { ValidationService } from '../shared/providers/validation.service';
import { UserManagerService } from '../shared/providers/user-manager.service';

@Component({
    selector: 'app-login-form',
    templateUrl: './login-form.component.html'
})

export class LoginFormComponent implements OnInit {

    loginModel = {} as ILogin;
    authResponse = {} as IUser;
    loginFailedMessage = '';
    classToBind: string = 'redtext';
    @Output() onLogin = new EventEmitter();
    checkEmailFailedMessage = '';

    checkEmailResponse = {} as ResultOutputModel;
    forgotPasswordModel = {} as IForgotPassword;
    socialLoginInputModel = {} as SocialLoginInputModel;
    socialLoginOutputModel = {} as SocialLoginOutputModel;

    isLoginActive = true;

    registerModel = {} as IRegister;
    registerResponse = {} as IRegisterOutput;
    registerFailedMessage = '';

    RoleValid: boolean = true;
    firstNameValid: boolean = true;
    lastNameValid: boolean = true;
    emailValid: boolean = true;
    passwordValid: boolean = true;
    confirmpasswordValid: boolean = true;
    phoneValid: boolean = true;
    emailvalidation: string = "";
    passwordValidation: string = "";
    showValidation: boolean = true;
    loopCount: number = 1;
    dis = true;
    private formSumitAttempt: boolean;
    @Input() modalRef: BsModalRef;
    @Input() updatePassword: boolean;
    @Input() updatePasswordUserGuid: string;
    stage = 1;
    //user: SocialUser;
    userRoleList: IUserRole[];
    redirectUrl = '';
    modalRefNew: BsModalRef;
    phoneValidation: string = "";
    permissions: IPermission[];
  constructor(private router: Router, private authService: AuthenticationService, private activatedRoute: ActivatedRoute, private registerService: RegisterService, private _toastService: ToastService,
        private forgotPasswordService: ForgotPasswordService,
        //private socialAuthService: AuthService,
        private _commonService: CommonService,
        private modalService: BsModalService, private Validation: ValidationService, private userManagerService: UserManagerService) { }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.registerModel.UtmId = params['utm_id'];
      this.registerModel.UtmSource = params['utm_source'];
      this.registerModel.UtmMedium = params['utm_medium'];
      this.registerModel.UtmCampaign = params['utm_campaign'];
      this.registerModel.UtmTerm = params['utm_term'];
      this.registerModel.UtmContent = params['utm_content'];
    });

        this._commonService.GetUserRolesWithFilter().subscribe(response => {
            this.userRoleList = response.map(o => { return { id: o.Id, name: o.Description }; });
        });
        this.forgotPasswordModel.Email = '';
        this.forgotPasswordModel.ConfirmationCode = null;
        this.forgotPasswordModel.ResetPassword = '';
        this.forgotPasswordModel.ConfirmPassword = '';
        this.classToBind = 'redtext';
        this.showValidation = true;
        this.registerModel.termsAndConditions = false;
        this.registerModel.is1031Exchange = false;
        this.registerModel.userrole = 0;

        if (this.updatePassword) {
            this.stage = 4;
        }

        this.authService.redirectUser.subscribe(res => {
            this.redirectUrl = res;
        });

        //this.user = null;
        //this.socialAuthService.signOut();
        //this.socialAuthService.authState.subscribe((user) => {          
        //    this.user = user;
        //    this.socialLogin();
        //});

        //this.registerModel.userrole = 2; //setting principal as default
    }

    signOut(): void {
        //this.user = null;
        //this.socialAuthService.signOut();
    }

    signInWithGoogle(): void {
        //this.loopCount = 1;
        //this.socialAuthService.signIn(GoogleLoginProvider.PROVIDER_ID);

    }

    signInWithFB(): void {
        this.loopCount = 1;
        // this.socialAuthService.signIn(FacebookLoginProvider.PROVIDER_ID);
    }

    //signInWithLinkedIn(): void {
    //    this.loopCount = 1;
    //    this.socialAuthService.signIn(LinkedInLoginProvider.PROVIDER_ID);       
    //}    

    //socialLogin() {
    //    
    //    if (this.user != null && this.user != undefined && this.loopCount == 1) {
    //        this.loopCount++;
    //        this.socialLoginInputModel.Email = this.user.email;
    //        this.socialLoginInputModel.Provider = this.user.provider;
    //        this.authService.checkSocialLoginUser(this.socialLoginInputModel).subscribe(response => {
    //            this.socialLoginOutputModel = response;
    //            if (this.socialLoginOutputModel.IsSuccess) {
    //                if (this.socialLoginOutputModel.LoginModel.Success == false) {
    //                    if (this.socialLoginOutputModel.Provider != null) {
    //                        this._toastService.addToast({ title: 'Waring', msg: 'You are already logged in with ' + this.socialLoginOutputModel.Provider, timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
    //                    }
    //                    else {
    //                        this._toastService.addToast({ title: 'Waring', msg: 'You are already logged in with B+E Account', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
    //                    }
    //                }
    //                else {
    //                    this.modalRef.hide();
    //                    this.onLoginOrRegisterClick(true);
    //                    this._toastService.addToast({ title: 'Success', msg: 'You are successfully logged in', timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
    //                    if (this.socialLoginOutputModel.LoginModel.RedirectUrl != "") // For 1031 access
    //                        this.router.navigateByUrl(this.socialLoginOutputModel.LoginModel.RedirectUrl);
    //                    window.scrollTo(0, 0);
    //                }
    //            }
    //            else {
    //                
    //                if (this.user != null && this.user != undefined) {
    //                    if (this.user.name != null && this.user.name != undefined) {
    //                        var name = this.user.name.split(" ");
    //                        this.registerModel.firstName = name[0];
    //                        if (name[1] != null && name[1] != undefined) {
    //                            this.registerModel.lastName = name[1];
    //                        }
    //                    }
    //                    if (this.user.photoUrl != undefined && this.user.photoUrl != null) {
    //                        this.registerModel.profilePicturePath = this.user.photoUrl;
    //                    }
    //                    this.registerModel.email = this.user.email;
    //                    this.registerModel.provider = this.user.provider;
    //                    this.isLoginActive = false;
    //                }
    //            }
    //        });
    //    }

    //}

    onKeydown(event) {
        if (event.key === "Enter") {
            this.onLoginClick();
        }
    }

    onForgotPasswordClick() {
        this.stage = 2;
    }

    changeModal(stage) {
        this.stage = stage;
    }

    onLoginClick() {

        if ((!this.loginModel.hasOwnProperty("UserName") && !this.loginModel.hasOwnProperty("Password")) ||
            this.loginModel.UserName == '' && this.loginModel.Password == '') {
            this.loginFailedMessage = "Username and password cannot be empty";
        }
        else if (!this.loginModel.hasOwnProperty("UserName") || this.loginModel.UserName == '') {
            this.loginFailedMessage = "Username cannot be empty";
        }
        else if (!this.loginModel.hasOwnProperty("Password") || this.loginModel.Password == '') {
            this.loginFailedMessage = "Password cannot be empty";
        }
        else {
            this.authService.login(this.loginModel).subscribe(response => {
                this.authResponse = response;
                if (this.authResponse.IsAuthenticated) {
                    this.modalRef.hide();

                    this.userManagerService.GetUserPermissions(this.authResponse.Id).subscribe(res => {
                        this.permissions = res;

                        localStorage.setItem("MenuPermissions", JSON.stringify(this.permissions));

                      if (this.authResponse.RoleId == this.authService.UserRole.Admin || this.authResponse.RoleId == this.authService.UserRole.SuperAdmin || this.authResponse.RoleId == this.authService.UserRole.DataEntryStaff) {
                            this.onLogin.emit(true);
                        }
                        this.onLoginOrRegisterClick(true);
                        this._toastService.addToast({ title: 'Success', msg: 'You are successfully logged in', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
                        if (this.authResponse.RedirectUrl != "") // For 1031 access
                        {
                            this.router.navigateByUrl(this.authResponse.RedirectUrl);
                        }
                        else if (this.redirectUrl != '') {
                            if ((this.authResponse.RoleId == this.authService.UserRole.Principal) || (this.authResponse.RoleId == this.authService.UserRole.Principal1031)) {
                                let URL = this.redirectUrl.split('/')[1];
                                if (URL != "") {
                                    this._commonService.IsOfferPlaced(URL, this.authResponse.Id).subscribe(res => {
                                        if (res == false) {
                                            this.router.navigateByUrl(this.redirectUrl);
                                        }
                                        this.clearRedeirectUrl();
                                    });
                                }
                            }

                        }
                        window.scrollTo(0, 0);
                    });
                }
                else {
                    this.loginFailedMessage = this.authResponse.FailureMessage;
                }
            });
        }
    }
    showFNSpecCharVal = false;
    showLNSpecCharVal = false;
    specCharValMsg = '!@#$%^&*()_+\-=\[\]{};"\\|<>\/? not allowed';
    onRegisterClick() {
        this.emailvalidation = "";
        this.classToBind = 'redtext';
        let valid: boolean = true;

        if (this.IsinValid(this.registerModel.userrole) || this.registerModel.userrole == 0) {
            this.RoleValid = false;
            valid = false;
        }
        else {
            this.RoleValid = true;
        }

        if (this.IsinValid(this.registerModel.firstName)) {
            this.firstNameValid = false;
            this.showFNSpecCharVal = false;
            valid = false;
        }
        else {
            if (this.Validation.isSpecialCharacterExist(this.registerModel.firstName)) {
                this.firstNameValid = false;
                valid = false;
                //this._toastService.addToast({ title: 'Warning', msg: 'First Name should not contain special characters', timeout: 3000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
                this.showFNSpecCharVal = true;
            }
            else {
                this.showFNSpecCharVal = false;
                this.firstNameValid = true;
            }
        }
        if (this.IsinValid(this.registerModel.lastName)) {
            this.lastNameValid = false;
            this.showLNSpecCharVal = false;
            valid = false;
        }
        else {
            if (this.Validation.isSpecialCharacterExist(this.registerModel.lastName)) {
                this.lastNameValid = false;
                valid = false;
                //this._toastService.addToast({ title: 'Warning', msg: 'Last Name should not contain special characters', timeout: 3000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
                this.showLNSpecCharVal = true;
            }
            else {
                this.showLNSpecCharVal = false;
                this.lastNameValid = true;
            }
        }

        if (this.registerModel.userrole == 0) {
            this.RoleValid = false;
            valid = false;
        }
        else {
            this.RoleValid = true;
        }

        if (this.IsinValid(this.registerModel.email)) {
            this.emailValid = false;
            valid = false;
        }
        else if (this.isEmail(this.registerModel.email) == false) {
            this.emailValid = false;
            this.emailvalidation = "";
        }
        else {
            this.emailValid = true;
            this.emailvalidation = "";
        }
        if (this.IsinValid(this.registerModel.password)) {
            this.passwordValid = false;
            valid = false;
        }
        else if (this.isPassword(this.registerModel.password) == false) {
            this.passwordValid = false;
            this.passwordValidation = "Must contain at least one number, one uppercase letter, one lowercase letter and at least 8 characters";
        }
        else {
            this.passwordValid = true;
        }
        if (this.IsinValid(this.registerModel.confirmpassword)) {
            this.confirmpasswordValid = false;
            valid = false;
        }
        else {
            this.confirmpasswordValid = true;
        }
        if (this.IsinValid(this.registerModel.phoneNumber)) {
            this.phoneValid = false;
            valid = false;
        }
        else {
            this.phoneValid = true;
        }

        if (valid) {

            if (this.isPassword(this.registerModel.password) == false) {
                this.passwordValid = false;
                this.passwordValidation = "Must contain at least one number, one uppercase letter, one lowercase letter and at least 8 characters";
                valid = false;
            }
            else {
                this.passwordValidation = "";
                this.passwordValid = true;
            }

            if (this.isEmail(this.registerModel.email) == false) {
                this.emailValid = false;
                this.emailvalidation = "Invalid email address";
                valid = false;
            }
            else if (this.registerModel.password.toString().trim() != this.registerModel.confirmpassword.toString().trim()) {
                this.registerFailedMessage = "Password and confirm password are not matching";
                valid = false;
            }
            else if (this.isPhoneNumber(this.registerModel.phoneNumber) == false) {
                this.registerFailedMessage = "Invalid phone number";
                valid = false;
            }
            else if (this.registerModel.termsAndConditions == false) {
                this.registerFailedMessage = "Please agree terms and conditions";
                valid = false;
            }
        }

        if (valid) {

            if (this.registerModel.user1031ExchangeStarts_Date != null) {
                //Converting Local Date into UTC Date
                let UTCDate = (this.registerModel.user1031ExchangeStarts_Date.toUTCString());
                this.registerModel.user1031ExchangeStarts = UTCDate;
            }
            else {
                this.registerModel.user1031ExchangeStarts = null;
            }

            if (this.registerModel.IsBroker) {

                this.registerModel.userrole = this.authService.UserRole.ExternalBroker;
            }

            this.registerService.registerUser(this.registerModel).subscribe(response => {
                this.registerResponse = response;
                if (this.registerResponse.Success) {
                    this.showValidation = false;
                    if (this.registerModel.is1031Exchange) {
                        this._toastService.addToast({ title: 'Success', msg: 'User registration successful. Your request to view 1031 properties is pending approval.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
                    }
                    else {
                        this._toastService.addToast({ title: 'Success', msg: 'User registered successfully.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
                    }
                    this.clearRegisterFeilds();
                    this.classToBind = 'greentext';
                    window.scrollTo(0, 0);
                    this.modalRef.hide();
                    this.onLoginOrRegisterClick(true);
                    if (this.redirectUrl != '') {
                        if (this.registerResponse.Role.toUpperCase().indexOf("PRINCIPAL") > -1) {
                            this.router.navigateByUrl(this.redirectUrl);
                        }
                        this.clearRedeirectUrl();
                    }
                    else if (this.authService.onRegisterRedirection != '') {
                        if (this.registerResponse.Role.toUpperCase().indexOf("PRINCIPAL") > -1) {
                            let href = this.authService.onRegisterRedirection;
                            this.authService.onRegisterRedirection = '';
                            this.router.navigateByUrl(href);
                        }
                    }
                    else {
                        let href = this.router.url;
                        this.router.navigate([href]);
                    }
                }
                else {
                    this.classToBind = 'redtext';
                    this.registerFailedMessage = this.registerResponse.FailureMessage;
                }

            });;
        }

    }

    clearRedeirectUrl() {
        this.authService.redirectUserTo('');
    }

    clearRegisterFeilds() {
        this.registerModel.firstName = null;
        this.registerModel.lastName = null;
        this.registerModel.email = null;
        this.registerModel.phoneNumber = '';
        this.registerModel.password = null;
        this.registerModel.is1031Exchange = false;
        this.registerModel.termsAndConditions = false;
        this.registerModel.user1031ExchangeStarts = null;
        this.registerModel.user1031ExchangeStarts_Date = null;
        this.registerModel.confirmpassword = null;
        this.classToBind = 'redtext';
        this.registerFailedMessage = null;
        this.registerModel.userrole = 0;

        this.RoleValid = true;
        this.firstNameValid = true;
        this.lastNameValid = true;
        this.emailValid = true;
        this.passwordValid = true;
        this.confirmpasswordValid = true;
        this.phoneValid = true;
        this.emailvalidation = "";
        this.showFNSpecCharVal = false;
        this.showLNSpecCharVal = false;
    }

    clearExchangeStart(eve: any) {

        if (this.registerModel.is1031Exchange == false) {
            this.registerModel.user1031ExchangeStarts = "";
            this.registerModel.user1031ExchangeStarts = "";
            this.registerModel.is1031Exchange = false;
        }
    }

    isEmail(search: string): boolean {
        var serchfind: boolean;
        var regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
        serchfind = regexp.test(search);
        return serchfind;
    }

    isPassword(search: string): boolean {
        var searchfind: boolean;
        var regexp = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})");
        searchfind = regexp.test(search);
        return searchfind;

    }
    isPhoneNumber(search: any) {
        var serchfind: boolean;
        var regexp = new RegExp(/^\d{10}$/);
        serchfind = regexp.test(search);
        return serchfind;
    }

    validateemail() {

        if ((this.isEmail(this.registerModel.email) == false) && !this.IsinValid(this.registerModel.email)) {
            this.emailValid = false;
            this.emailvalidation = "invalid Email address";
        }
        else {
            this.emailValid = true;
            this.emailvalidation = "";
        }
        if (this.IsinValid(this.registerModel.email)) {
            this.emailValid = false;
        }
    }
    forgotPasswordValidation = '';
    forgotPasswordValid = true;
    validateForgotPassword() {
        if ((this.isPassword(this.forgotPasswordModel.ResetPassword) == false) && !this.IsinValid(this.forgotPasswordModel.ResetPassword)) {
            this.forgotPasswordValid = false;
            this.forgotPasswordValidation = "Must contain at least one number, one uppercase letter, one lowercase letter and at least 8 characters";
        }
        else {
            this.forgotPasswordValid = true;
            this.forgotPasswordValidation = "";
        }
        if (this.IsinValid(this.forgotPasswordModel.ResetPassword)) {
            this.forgotPasswordValid = false;
        }
        else {
            this.forgotPasswordValid = true;
        }
    }

    validatepassword() {
        if ((this.isPassword(this.registerModel.password) == false) && !this.IsinValid(this.registerModel.password)) {
            this.passwordValid = false;
            this.passwordValidation = "Must contain at least one number, one uppercase letter, one lowercase letter and at least 8 characters";
        }
        else {
            this.passwordValid = true;
            this.passwordValidation = "";
        }
        if (this.IsinValid(this.registerModel.password)) {
            this.passwordValid = false;
        }
        else {
            this.passwordValid = true;
        }
    }

    IsinValid(value: any) {

        if (value == undefined || value == '' || value == null) {
            return true;
        }
        if (value.toString().trim().length <= 0) {
            return true;
        }
        if (!value) {
            return true;
        }
        return false;
    }

    onLoginOrRegisterClick(tab: boolean) {
        this.isLoginActive = tab;
        if (tab) {
            this.showValidation = false;
            this.clearRegisterFeilds();
        }
        else
            this.clearLoginFields();
    }

    onCheckEmailClick() {
        $('#aForgotPasswordId').hide();
        this.checkEmailFailedMessage = '';
        if (this.forgotPasswordModel.Email == '' || this.forgotPasswordModel.Email == undefined) {
            this.checkEmailFailedMessage = "Email cannot be empty"
        }
        else {
            this.forgotPasswordService.checkEmail(this.forgotPasswordModel).subscribe(response => {
                this.checkEmailResponse = response;
                if (this.checkEmailResponse.Success) {
                    this.stage = 3;
                    this.forgotPasswordModel.Email = '';
                }
                else {
                    this.checkEmailFailedMessage = this.checkEmailResponse.ReturnMsg;
                }
            });
        }
    }

    onConfirmationCodeClick() {
        this.checkEmailFailedMessage = '';
        if (this.forgotPasswordModel.ConfirmationCode == null || this.forgotPasswordModel.ConfirmationCode == undefined) {
            this.checkEmailFailedMessage = "Confirmation code cannot be empty"
        }
        else {
            this.forgotPasswordModel.Guid = this.checkEmailResponse.Guid;
            this.forgotPasswordService.checkConfirmationcode(this.forgotPasswordModel).subscribe(response => {
                if (response.Success) {
                    this.checkEmailResponse = response;
                    this.stage = 4;
                    this.forgotPasswordModel.ConfirmationCode = null;
                }
                else {
                    this.checkEmailFailedMessage = 'Please enter valid confirmation code';
                }
            });
        }
    }

    onResetPasswordClick() {
        //this.modalRefNew.hide();
        this.checkEmailFailedMessage = '';
        if (this.IsPasswordValid()) {
            if (this.updatePassword) {
                this.forgotPasswordModel.Guid = this.updatePasswordUserGuid;
            }
            else {
                this.forgotPasswordModel.Guid = this.checkEmailResponse.Guid;
            }

            this.forgotPasswordService.resetPassword(this.forgotPasswordModel).subscribe(response => {
                if (response) {
                    this._toastService.addToast({ title: 'Success', msg: 'Your password has been changed successfully!', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
                    this.modalRef.hide();
                }
                else {
                    this.checkEmailFailedMessage = 'Update failed.Try again';
                }
            });
        }
    }

    IsPasswordValid() {
        let valid = true;
        if (this.forgotPasswordModel.ResetPassword == '' || this.forgotPasswordModel.ResetPassword == undefined) {
            this.checkEmailFailedMessage = "New Password cannot be empty";
            valid = false;
        }
        else if (this.forgotPasswordModel.ConfirmPassword == '' || this.forgotPasswordModel.ConfirmPassword == undefined) {
            this.checkEmailFailedMessage = "Confirm Password cannot be empty";
            valid = false;
        }
        else if (this.forgotPasswordModel.ConfirmPassword != this.forgotPasswordModel.ResetPassword) {
            this.checkEmailFailedMessage = "The New Password and Confirm Password you entered do not match.";
            valid = false;
        }
        else if (this.isPassword(this.forgotPasswordModel.ResetPassword) == false) {
            this.forgotPasswordValid = false;
            valid = false;
            this.forgotPasswordValidation = "Must contain at least one number, one uppercase letter, one lowercase letter and at least 8 characters";
        }
        return valid;
    }
    validatePhoneNumber() {
        if (this.isPhoneNumber(this.registerModel.phoneNumber) == false) {
            this.phoneValidation = "Invalid phone number";
        }
        else {
            this.phoneValidation = "";
        }
    }

    clearLoginFields() {
        this.loginModel.UserName = '';
        this.loginModel.Password = '';
        this.loginFailedMessage = '';
    }
    RoleChange() {
        this.registerModel.is1031Exchange = false;
        if (this.registerModel.userrole !== 0) {
            this.RoleValid = true;
        }
    }

    openModal(template: TemplateRef<any>, classes: any) {
        if (this.IsPasswordValid()) {
            this.modalRefNew = this.modalService.show(template, { class: classes });
        }
    }
    emailFailMessageHide() {
        this.checkEmailFailedMessage = "";
    }
    onCheckboxSelect(type: number) {

        if (type == 1) {
            this.registerModel.IsBroker = false;
        }
        else {
            this.registerModel.is1031Exchange = false;
        }
    }
}
